module.exports = __webpack_public_path__ + "static/buehne_jobs-b6271c522759b4d012758601dac86012.svg";